import React, { useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDIcon,
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack, FDTooltip,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { metaOverrideSet } from './metaOverrideSet';

const useStyles = buildUseStyles('GuidedHouseholdReviewFoundationalGoalsLayout', () => ({
  img: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    width: '60vw',
    maxHeight: '80vh',
    zIndex: -1, // Allows the tooltips to work even when the image of stairs is technically covering them
  },
}));

export const GuidedHouseholdReviewFoundationalGoalsLayout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const classes = useStyles();
  const [imgLoaded, setImgLoaded] = useState(!resource.relationship(fr.relationships.image.name));
  const [expanded, setExpanded] = useState(false);
  const goals = resource.attr('goalList')?.resources()?.list() ?? [];
  return (
    <FDStack direction="column" spacing={3} justifyContent="center">
      <img
        src={resource.relationship(fr.relationships.image.name).link('related').url()}
        className={classes.img}
        alt=""
        onLoad={() => setImgLoaded(true)}
      />
      {imgLoaded ? (
        <FDStack direction="column" spacing={3} justifyContent="flex-start" alignItems="flex-start" width="50%" padding={8}>
          <MetaControlField attr="title" />
          <MetaControlField attr="description" />
          {expanded
            ? (
              <FDStack spacing={2} direction="column">
                {goals.map(goal => (
                  <FDStack key={goal.id()} spacing={4} alignItems="center">
                    <FDIcon icon={goal.attr('icon')} size="lg" color="attention" />
                    <MetaControl resource={goal} metaOverrideSet={metaOverrideSet} attrName="name" />
                  </FDStack>
                ))}
              </FDStack>
            )
            : (
              <>
                <FDStack spacing={4} paddingY={4}>
                  {goals.map(goal => (
                    <FDTooltip key={goal.id()} title={goal.attr('name')} placement="bottom">
                      <FDIcon icon={goal.attr('icon')} size="xl" color="attention" />
                    </FDTooltip>
                  ))}
                </FDStack>
              </>
            )
          }
          <FDStack direction="row" justifyContent="flex-start" spacing={2}>
            <FDSecondaryActionButton
              size="lg"
              onClick={() => setExpanded(true)}
              disabled={expanded}
              label="Learn more"
            />
            <FDPrimaryActionButton
              size="lg"
              {...dataAttrs('submit-btn')}
              loading={saving}
              onClick={onSubmit}
              label={resource.attr('primaryActionLabel') || 'Submit'}
            />
          </FDStack>
        </FDStack>
      ) : null}
    </FDStack>
  );
};
